function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  'use strict';

  angular.module('wsLrs.services').factory("Dashboards", ['$q', '$rootScope', '$http', 'Api', 'Logger', 'User', 'wsEventNames', 'CardRegistry', function ($q, $rootScope, $http, Api, Logger, User, wsEventNames, CardRegistry) {
    // Any tenant bound API urls must be reset when the org changes
    $rootScope.$on('organization-selected', function () {
      self.__value = null;
    });
    var self = {
      __value: null,
      currentDashboard: null,
      changeCurrentDashboard: function changeCurrentDashboard(dashboard) {
        var defer = $q.defer();
        if (_.isNull(dashboard) || _.isUndefined(dashboard)) {
          defer.reject();
        } else {
          self.currentDashboard = dashboard;
          var user = User.get();
          $rootScope.$broadcast(wsEventNames.dashboard.selected, self.currentDashboard);
          var updateDashboard = function updateDashboard(updatedUser) {
            $http.put(Api.url("/memberships/" + updatedUser.membership.id, true), updatedUser.membership).then(function () {
              User.set(updatedUser);
            });
          };
          if (dashboard.id === user.membership.defaultDashboardId || !_.isNumber(dashboard.id)) {
            defer.resolve();
            return defer.promise;
          } else if (user.isSingleSignOn && !user.membership.defaultDashboardId) {
            // If this is the first time the user signs in, get the first dashboard in the list
            // dashboards the user has permission to, sorted by the menu position.
            $http.get(Api.url("/dashboards?_limit=1000")).then(function (response) {
              var dashboards = response.data.results;
              var topLevelDashboards = _.filter(dashboards, function (d) {
                return d.dashboardCategoryName === "None";
              });
              topLevelDashboards = _.sortBy(topLevelDashboards, 'menuPosition');
              user.membership.defaultDashboardId = topLevelDashboards[0].id;
              return updateDashboard(user);
            }).catch(function () {
              user.membership.defaultDashboardId = dashboard.id;
              return updateDashboard(user);
            });
          } else {
            user.membership.defaultDashboardId = dashboard.id;
            if (_.isUndefined(user.membership.id)) {
              defer.resolve();
            } else {
              return updateDashboard(user);
            }
          }
        }
      },
      get: function get(nameSearchTerm) {
        var user = User.get();
        if (!user || !user.membership) {
          return $q.resolve([]);
        }
        var url = Api.url("/dashboards?_limit=1000", false);
        if (nameSearchTerm) {
          url += "&in_name=" + nameSearchTerm;
        }
        if (!self.__value) {
          self.__value = $http.get(url).then(function fetchDashboardsSuccess(response) {
            var dashboards = response.data.results;
            if (!(self.currentDashboard && self.currentDashboard.name === "Your Reports")) {
              dashboards = _.sortBy(dashboards, function (d) {
                return d.menuPosition;
              });
              self.changeCurrentDashboard(_.findWhere(dashboards, {
                id: user.membership.defaultDashboardId
              }) || _.findWhere(dashboards, {
                name: "Dashboard"
              }) || dashboards[0]);
              $rootScope.$broadcast(wsEventNames.nav.update);
            }
            return dashboards;
          }, function fetchDashboardsError(response) {
            Logger.error("Dashboards fetch failed with response status " + response.status);
            return [];
          });
        }
        return self.__value;
      },
      getMenu: function getMenu(forceRefreshFromServer) {
        if (forceRefreshFromServer) {
          self.__value = null;
        }
        return $q.all([self.get(), $http.get(Api.url("/dashboard-categories"))]).then(function (response) {
          var dashboards = response[0];
          // We only want non-empty categories here
          var categories = _.filter(response[1].data.results, function (c) {
            if (c.dashboards === undefined) {
              return false;
            }

            // Filter out dashboards they don't have permissions to, and only include
            // categories that have permitted dashboards
            var permittedDashboards = _.filter(c.dashboards, function (catDashboard) {
              return _.findWhere(dashboards, {
                id: catDashboard.id
              });
            });
            c.dashboards = permittedDashboards;
            return c.dashboards !== undefined && c.dashboards.length > 0;
          });

          // Pull out top level menu items
          var menuItems = _.filter(dashboards, function (d) {
            return d.dashboardCategoryName === "None";
          });

          // Add all the categories as well
          menuItems = menuItems.concat(categories);
          menuItems = _.sortBy(menuItems, 'menuPosition');
          return menuItems;
        });
      },
      getCards: function getCards() {
        var cards = [];
        if (!this.currentDashboard) {
          return cards;
        }
        try {
          cards = this.currentDashboard.cardIds.map(function (id) {
            return CardRegistry.get(id);
          });
        } catch (e) {
          Logger.error("Error fetching cards on current dashboard.", e);
        }
        return cards;
      },
      update: function update() {
        self.clearCache();
        return self.get();
      },
      clearCache: function clearCache() {
        self.__value = null;
      },
      forCardsOnCurrentDashboard: function forCardsOnCurrentDashboard(callback) {
        if (!this.currentDashboard) {
          return;
        }
        try {
          var cardIdsOnDashboard = this.currentDashboard.cardIds;
          var _iterator = _createForOfIteratorHelper(cardIdsOnDashboard),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var cardId = _step.value;
              var card = CardRegistry.get(cardId);
              var breakLoop = callback(card);
              if (breakLoop) {
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } catch (e) {
          Logger.error("Error while iterating over cards on current dashboard.", e);
        }
      }
    };
    return self;
  }]);
})();
